export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/sleep-tangerine.8751d74b530006d7d64194d2bb6c9716.png";